import axios from 'axios';

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': 'pc_live_7f9a2c8e4d6b1a5f3c0e9d8b7a2f6c4e'
  }
});

export default api;